import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import {
  Box,
  Container,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  styled,
  useMediaQuery,
} from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'

const PREFIX = 'stepper'

const classes = {
  root: `${PREFIX}-root`,
  containerStepper: `${PREFIX}-container-stepper`,
  stepIcon: `${PREFIX}-step-icon`,
  stepLabel: `${PREFIX}-step-label`,
  mobileStepLabel: `${PREFIX}-mobile-step-label`,
  active: `${PREFIX}-active`,
}

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.root}`]: {
    padding: theme.spacing(2, 0),
    minHeight: 'initial',
    background: '#ffffff',
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'row',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  [`& .${classes.containerStepper}`]: {
    width: '80%',
  },
  [theme.breakpoints.down('sm')]: {
    [`& .${classes.stepIcon}`]: {
      fontSize: theme.spacing(1.5),
      color: theme.palette.grey[500],
      marginTop: theme.spacing(0.2),
    },
    [`& .${classes.mobileStepLabel}`]: {
      display: 'inline-flex',
      fontSize: theme.spacing(1.3),
      color: theme.palette.grey[500],
      alignItems: 'center',
    },
    [`& .${classes.active}`]: {
      color: theme.palette.primary.main,
      textDecoration: 'underline',
      fontWeight: 700,
    },
  },
}))

M1Stepper.propTypes = {
  activeStep: PropTypes.number,
  steps: PropTypes.array,
}

export default function M1Stepper(props) {
  const { activeStep, steps } = props
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'))
  const mobileStepper = (
    <Container sx={{ display: { xs: 'block', sm: 'none' } }}>
      {steps &&
        steps.map((step, index) => {
          if (!step.canSkip) {
            return (
              <div
                key={step.label}
                className={
                  activeStep === index
                    ? [classes.mobileStepLabel, classes.active].join(' ')
                    : classes.mobileStepLabel
                }
              >
                {step.label}
                {index !== steps.length - 1 && (
                  <KeyboardArrowRightIcon className={classes.stepIcon} />
                )}
              </div>
            )
          }
        })}
    </Container>
  )

  const desktopStepper = (
    <Stepper
      activeStep={activeStep}
      className={classes.containerStepper}
      sx={{ display: { xs: 'none', sm: 'flex' } }}
      connector={<StepConnector sx={{ borderTop: '4px' }} />}
    >
      {steps &&
        steps.map((step) => {
          if (!step.canSkip) {
            const stepProps = {}
            const labelProps = {
              icon: step.icon,
            }
            return (
              <Step key={step.label} {...stepProps}>
                <StepLabel {...labelProps} className={classes.stepLabel}>
                  {step.label}
                </StepLabel>
              </Step>
            )
          }
        })}
    </Stepper>
  )

  return (
    <StyledBox className={classes.root}>
      {!isMobile ? desktopStepper : mobileStepper}
    </StyledBox>
  )
}
